module.exports = __webpack_public_path__ + "img/cross sell Up Cadou.b20ca21e.jpeg";